import React from 'react';
import './NameEntry.css';

const VISITOR_TYPE_KEY = 'portfolio_visitor_type';

const NameEntry = ({ onVisitorTypeSubmit }) => {
  const handleTypeSelection = (type) => {
    localStorage.setItem(VISITOR_TYPE_KEY, type);
    onVisitorTypeSubmit(type);
  };

  return (
    <div className="name-entry-container">
      <div className="backdrop"></div>
      <div className="name-entry-content">
        <h1>Hello!</h1>
        <p>Welcome to my portfolio. Are you a friend or a recruiter?</p>
        
        <div className="button-group">
          <button 
            className="type-button friend-button"
            onClick={() => handleTypeSelection('friend')}
            aria-label="I am a friend"
          >
            I'm a Friend
          </button>
          <button 
            className="type-button recruiter-button"
            onClick={() => handleTypeSelection('recruiter')}
            aria-label="I am a recruiter"
          >
            I'm a Recruiter
          </button>
        </div>
      </div>
    </div>
  );
};

export default NameEntry;
